import React from "react";
import styled from "styled-components";
import { Button, Checkbox, MenuItem } from "@material-ui/core";
import { RefreshOutlined as RefreshOutlinedIcon } from '@material-ui/icons';

import {Basis, Days} from "components/EditJob";
import {FilterOption} from "../types";

import {
  StyledCrossButtonDark,
  StyledFormControlLabel,
  CheckboxLabel,
  StyledMaterialSelector,
  ResetFiltersButton,
} from "../AvailablePositions.styles";

interface FilterOptionsProps {
  onClose: () => void
  availabilityFilter: FilterOption[]
  onSetAvailabilityFilter: (id: number, checked: boolean) => void
  basisFilter?: FilterOption
  onSetBasisFilter: (id: number) => void
  onFiltersApply: () => void
  onFiltersReset: () => void
}

// T2-6046: Compact filter pop-up — was previously full-width with very tall
// vertical spacing. Now constrained to max-width 480px, tighter padding and a
// single sticky footer row (Reset / Apply) instead of two stacked sections.
const CompactPopupContainer = styled.div`
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  padding: 1rem 1.25rem 1.25rem;
  border-radius: 12px;
  background: white;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.14);
  box-sizing: border-box;
`

const CompactHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
`

const CompactTitle = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
`

const SectionLabel = styled.div`
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.75);
  margin: 0.5rem 0 0.25rem;
`

const CompactCheckboxesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 0.5rem;
  margin-bottom: 0.75rem;
`

const SelectorWrap = styled.div`
  margin-bottom: 1rem;
`

const FooterRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;

  & > button {
    flex: 1;
  }
`

const FilterOptions = ({
                         availabilityFilter,
                         onSetAvailabilityFilter,
                         onClose,
                         basisFilter,
                         onSetBasisFilter,
                         onFiltersApply,
                         onFiltersReset
}: FilterOptionsProps) => {
  return (
    <CompactPopupContainer>
      <CompactHeader>
        <CompactTitle>Filters</CompactTitle>
        <StyledCrossButtonDark onClick={onClose}/>
      </CompactHeader>

      <SectionLabel>Which days are you looking to work?</SectionLabel>
      <CompactCheckboxesGrid>
        {Days.map(({id, text}) => (
          <StyledFormControlLabel
            key={id}
            className="no-fastclick"
            control={<Checkbox
              name={`days-${id}`}
              size="small"
              checked={availabilityFilter.some((option) => option.id === id)}
              onChange={(event, checked) => onSetAvailabilityFilter(id, checked)}
              icon={<img id="officeCheckmark" className="hidden-icon" alt=""
                         src={"img/checkboxUnchecked.svg"}/>}
              checkedIcon={<img id="officeCheckmark" className="hidden-icon" alt=""
                                src={"img/checkboxChecked.svg"}/>}
            />} label={<CheckboxLabel>{text}</CheckboxLabel>}/>
        ))}
      </CompactCheckboxesGrid>

      <SelectorWrap>
        <StyledMaterialSelector
          id="basis"
          value={basisFilter ? basisFilter.id : ''}
          name="basis"
          label="Contract Type"
          onChange={(event) => onSetBasisFilter(event.target.value)}
        >
          {Basis.map(({id, text}) => <MenuItem key={id} value={id}>{text}</MenuItem>)}
        </StyledMaterialSelector>
      </SelectorWrap>

      <FooterRow>
        <ResetFiltersButton
          variant="outlined"
          onClick={onFiltersReset}
          startIcon={<RefreshOutlinedIcon />}
          color="primary"
          size="medium"
          id="reset-button"
        >
          Reset
        </ResetFiltersButton>
        <Button
          variant="contained"
          onClick={onFiltersApply}
          color="primary"
          size="medium"
          id="continue-button"
          style={{
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
          }}
        >
          Apply
        </Button>
      </FooterRow>
    </CompactPopupContainer>
  );
}

export default FilterOptions;
